import { GroupSquares, GroupSquaresContext } from 'global/wrappers/GroupSquares';
import _ from 'lodash';
import useGoogleSports from 'projectSpecific/sports/useHelpers/useGoogleSports';
import { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { SportsDistrictContext } from '../../cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { matchStatusTypes, sportsDataHandlers, sportsDataInitialState, sportsDataReducer } from '../../cnr/reducers/SportsDataReducer';
import { _sdm } from '../dashboard/SportsDashboard';
import { useMatchCompare } from 'projectSpecific/sports/useHelpers/useMatchCompare';
import { useSportsMatches } from 'projectSpecific/sports/useHelpers/useSportsMatches';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import MatchSquares from './MatchSquares';
import { Label } from 'semantic-ui-react';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import { _matchSeasonalCollection } from 'projectSpecific/sports/useHelpers/useSportRealtimeResults';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { seasonalUpdateTypes } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { useSeasonalDataHelpers } from 'projectSpecific/sports/useHelpers/useSeasonalDataHelpers';

export const _mediaModes = {
  results: 'results',
  playoffResults: 'playoffResults',
}

export const _resultModes = {
  ammend: 'ammend',
  backup: 'backup',
  export: 'export',
  media: 'media',
  openExternal: 'openExternal',
  scores: 'scores',
  search: 'search',
}

export const _fetchModes = {
  results: 'results',
  playoffResults: 'playoffResults',
  resultsMedia: 'resultsMedia',
  playoffResultsMedia: 'playoffResultsMedia',
  wpialResults: 'wpialResults',
}

export const MatchDataUpdateContext = createContext();

const MatchResults = (props) => {

  const { sportsDataMode, fromApp, currentMenuKey } = props

  const { updateSeasonalMatches_byLevel, updating } = useSeasonalDataHelpers()
  const { getMatches_flat, analyzeMatches, compareMatches, getMatches_dotUpdates } = useSportsMatches()

  const groupSquaresContext = useContext(GroupSquaresContext)
  const { groupSquares_state, groupSquares_handlers } = groupSquaresContext ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state

  const database_fns = _.get(parentContext, 'fns.database_fns')

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sportPermissions } = sportsDistrict_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    gameScoringType,
    currentSeason_info,
    links_score,
    matches_info,
    teams_info,
    sportSettings_info,
    sportsShowOptions,
  } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const { matchDate } = sportsShowOptions ?? {}

  // sportsData
  const init_state = {
    database_fns,
    fn_cls,
    gameScoringType,
    latestSeason,
    links_score,
    mainDb,
    matches_info,
    pathViews,
    sportPermissions,
    sportsKey,
    teams: teams_info && teams_info.teams,
    useScoringCollection,
    useScoringCollectionOnly,
  }

  const [sportsData_state, sportsData_dispatch] = useReducer(sportsDataReducer, init_state, sportsDataInitialState)
  const sportsData_handlers = sportsDataHandlers(sportsData_dispatch, sportsData_state)

  const [currentMatchUpdates, setCurrentMatchUpdates] = useState()
  const [matchResultsInfo, setMatchResultsInfo] = useState()
  const [fetchMode, setFetchMode] = useState()


  const forPlayoffs = (fm) => {
    switch (fm) {
      case _fetchModes.playoffResults:
      case _fetchModes.playoffResultsMedia:
        return true;
      default:
        return false
    }
  }

  const {
    filterType,
  } = sportsData_state ?? {}

  const matches_flat = useMemo(() => {
    if (!matches_info) return;
    return getMatches_flat({ matches_info })
  }, [matches_info])

  const { handleGet_gsMatches, fetching } = useGoogleSports({
    currentMenuKey,
    sportsDataMode,
    // matches_flat,
    // matches_info,
    gameScoringType,
  })

  let btn_prefix = 'Update';

  switch (filterType) {
    case matchStatusTypes.season:
    case matchStatusTypes.seasonPlayoff:
      btn_prefix = 'Refresh'
      break;
    default:
      btn_prefix = 'Update'
  }

  // useEffect(() => {
  //   switch (sportsDataMode) {
  //     case _sdm.sports.seasonResults:
  //       sportsData_handlers && sportsData_handlers.handleGet_matchesFlatData(matchDate)
  //     default:
  //     // nothing
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, []);



  const { counts } = matches_flat ?? {}
  const { filtered: filtered_count } = counts ?? {}

  let headerCount;

  if (filtered_count) {
    headerCount = filterType ? _.startCase(filterType) + ' (' + filtered_count + ')' : 'All (' + filtered_count + ')'
  }

  const updateResults = () => {

    const cb = () => {

    }

    const { matchUpdates_data_current } = matchResultsInfo ?? {}
    const _latestSeason = latestSeason

    const { updates_app } = currentMatchUpdates ?? {}
    const { updates_app_dot, updates_grouped } = getMatches_dotUpdates({ updates_app })

    const _updateProps = {
      collectionName: _matchSeasonalCollection,
      forPlayoffs: forPlayoffs(fetchMode),
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, _latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      useScoringCollection,
      useScoringCollectionOnly,
      sportPermissions,
      dataToUpdate: matchUpdates_data_current,
      // dataToUpdate: updates_app_dot,
      callback: cb
    }

    console.group('handleUpdate_matches')
    console.log('matchUpdates_data_current', matchUpdates_data_current)
    console.log('updates_app', updates_app)
    console.log('updates_grouped', updates_grouped)
    console.log('updates_app_dot', updates_app_dot)
    console.groupEnd()


    // console.groupEnd()

    updateSeasonalMatches_byLevel(_updateProps)

  }
  const header_flex = (caption, count) => <div className='header-flex'>
    <div>{caption}</div>
    <div>
      <Label size='mini'>{count}</Label>
    </div>
  </div>

  // const footer_results = (count) => {
  //   const items = []
  //   let icon_sub = 'arrow right';
  //   const _updateDisabled_scores = matchUpdates ? false : true //!gsMatchedRefreshed || !updateAllowed
  //   btn_itemRight(items, icon_sub, _updateCaption_results, _rightModes_mdu.confirmResults, _updateDisabled_scores || _.isEmpty(matchUpdates))
  //   return <UiSaveButtons
  //     others={items}
  //     color={'blue'}
  //   />
  // }

  const fnCurrentGroup = (cg) => {
    switch (cg.key) {
      case _fetchModes.results:
      case _fetchModes.playoffResults:
        const { matchUpdates } = matchResultsInfo ?? {}
        if (matchUpdates) {
          const count = matchUpdates ? _.size(matchUpdates) : 0
          const _caption = _.startCase('updatedMatches')
          return <Wrapper
            header={header_flex(_caption, count)}
            content={count > 0 ? <MatchSquares matches={matchUpdates} showChanges={true} fromLookup={true} /> : <NoData fullCaption={'None'} />}
            wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
            footer={<UiSaveButtons save={{ oc: updateResults }} color={_allowSportsUpdates.matches ? 'green' : 'teal'} />}
            css={{ content: count === 0 ? 'hwcc' : null }}
          ></Wrapper >
        }
        return <div>{cg.key}</div>

      case _fetchModes.resultsMedia:

      case _fetchModes.playoffResultsMedia:

      case _fetchModes.wpialResults:
    }
    return '???'
  }

  const fnTrigger = (key) => {

    const cb = (_matchResultsInfo) => {
      const amm = analyzeMatches({ matches_gs: _matchResultsInfo?.matches_gs, matches_app: matches_info?.matches_combined, teams: teams_info.teams })
      const zzz = compareMatches({ matches_gs: _matchResultsInfo?.matches_gs, matches_app: matches_info?.matches_combined, teams: teams_info.teams })

      console.group('trigger')
      console.log('updates_app', amm)
      console.log('zzz', zzz)
      console.log('matchesNew', _.groupBy(zzz?.groupedUpdates?.matchesNew, '_matchCollectionKey'))
      console.log('scoresNew', _.groupBy(zzz?.groupedUpdates?.scoresNew, '_matchCollectionKey'))
      console.log('startDateChanges', _.groupBy(zzz?.groupedUpdates?.startDateChanges, '_matchCollectionKey'))

      const { updates_app } = amm ?? {}
      const { updates_app_dot, updates_grouped } = getMatches_dotUpdates({ updates_app })
      console.log('updates_grouped', updates_grouped)
      console.log('_matchResultsInfo', _matchResultsInfo)
      console.groupEnd()

      setMatchResultsInfo(_matchResultsInfo)
      setCurrentMatchUpdates(amm)
      setFetchMode(key)
    }
    const cbe = (_matchResultsInfo) => {
      setMatchResultsInfo(null)
      setCurrentMatchUpdates(null)
      setFetchMode(key)
    }
    const opts = { fetchMode: key, forPlayoffs: forPlayoffs(key) }
    handleGet_gsMatches({ opts, matches_flat, callback: cb, callback_error: cbe })

    // switch (key) {
    //   case _fetchModes.results:
    //     const cb = (_matchResultsInfo) => {
    //       setMatchResultsInfo(_matchResultsInfo)
    //     }
    //     const opts = { fetchMode: _fetchModes.results }
    //     ugs.handleGet_gsMatches({ opts, matches_flat, callback: cb })
    //   case _fetchModes.playoffResults:

    //   case _fetchModes.resultsMedia:

    //   case _fetchModes.playoffResultsMedia:

    //   case _fetchModes.wpialResults:
    // }
  }

  const gs = () => <GroupSquares
    menuItems={_fetchModes}
    fnCurrentGroup={fnCurrentGroup}
    fnTrigger={fnTrigger}
    updating={fetching}
    caption={'Results Options'}
    iconItem={'external alternate'}
    noHeader={true}
  />

  return gs()
}

export default MatchResults

